var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelOracleAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55 10.3a7.7 7.7 0 0 1 14.9 0M19.45 13.7a7.7 7.7 0 0 1-14.9 0",
    stroke: "currentColor",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.35,
    cy: 12,
    r: 1.45,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.65,
    cy: 12,
    r: 1.45,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20.65,
    r: 1.45,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.85 17.05 7.8 12 10.75 6.95 7.8 12 4.85Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 8.95 11.25 11.65v6.1l-4.6-2.7v-6.1Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 8.95 12.75 11.65v6.1l4.6-2.7v-6.1Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35 12h3.3M17.35 12h3.3M12 17.75v2.9",
    stroke: "currentColor",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.95,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelOracleAi);
export default __webpack_public_path__ + "static/media/model-oracle-ai.770f6ff26b7f18489e7c6b6904152815.svg";
export { ForwardRef as ReactComponent };